import ABCyaPhaser from "@abcya/abcya_phaser";

export function onMuteButtonClicked(Scene,Button)
{
    let MutedFrame = "Btn_SndOff";
    let UnmutedFrame = "Btn_SndOn";
    let MutedText = ABCyaPhaser.Localization.instance.getLocalizedString("sound_off_button");
    let UnMutedText = ABCyaPhaser.Localization.instance.getLocalizedString("sound_on_button");

    if(Button.getAt(0).frame.name === UnmutedFrame)
    {
        Scene.sound.mute = true;
        Button.getAt(0).setFrame(MutedFrame);
        Button.getAt(1).setText(MutedText);
    }
    else if(Button.getAt(0).frame.name === MutedFrame)
    {
        Scene.sound.mute = false;
        Button.getAt(0).setFrame(UnmutedFrame);
        Button.getAt(1).setText(UnMutedText);
    }
}